/**
 * @generated SignedSource<<f877598bf73eb62a042479a6a206ea64>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productSidePanelContent_LibraryMaterialQuery$variables = {
  id: any;
};
export type productSidePanelContent_LibraryMaterialQuery$data = {
  readonly libraryMaterial: {
    readonly materialID: any;
    readonly name: string;
  } | null;
};
export type productSidePanelContent_LibraryMaterialQuery = {
  response: productSidePanelContent_LibraryMaterialQuery$data;
  variables: productSidePanelContent_LibraryMaterialQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "materialID",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_LibraryMaterialQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Material",
        "kind": "LinkedField",
        "name": "libraryMaterial",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "productSidePanelContent_LibraryMaterialQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Material",
        "kind": "LinkedField",
        "name": "libraryMaterial",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7029f38be45f0b3903d4f672cf2daa9a",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_LibraryMaterialQuery",
    "operationKind": "query",
    "text": "query productSidePanelContent_LibraryMaterialQuery(\n  $id: UUID!\n) {\n  libraryMaterial(id: $id) {\n    materialID\n    name\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f93a312bf7ecf40ee3396e10af9242c4";

export default node;
